/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Description_PlaceholderInputs */

const en_ui_studio_marker_description_placeholder = /** @type {(inputs: Ui_Studio_Marker_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional notes`)
};

const de_ui_studio_marker_description_placeholder = /** @type {(inputs: Ui_Studio_Marker_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionale Notizen`)
};

/**
* | output |
* | --- |
* | "Optional notes" |
*
* @param {Ui_Studio_Marker_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_description_placeholder = /** @type {((inputs?: Ui_Studio_Marker_Description_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Description_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_description_placeholder(inputs)
	return de_ui_studio_marker_description_placeholder(inputs)
});